import { useMemo } from 'react';

export const usePage = (data, currentPage, pageSize) => {
    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return data?.slice(startIndex, endIndex) ?? [];
    }, [data, currentPage, pageSize]);

    return paginatedData;
};
